import React, {useState, Suspense} from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "publish/layout/LayoutAside";
import Breadcrumb from 'layouts/admin/Breadcrumb';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UISunEditor from "components/wysiwygeditor/UISunEditor";
import UI from "components/UI";
import UIDatePicker from "components/datepicker";
import UIUtils from "utils/UIUtils";
import DateUtil from "../../../../utils/DateUtil";
import CommonUtil from "../../../../utils/CommonUtil";
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";

function ContentsContainer() {
	const history = useHistory();
	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const dmdNo = receivedData?.DEMAND_NO;
	const [demandDetail, setDemandDetail] = useState<any>([]);

	const [stsCd, setStsCd] = useState('Y');
	const [title, setTitle] = useState('');
	const [cont, setCont] = useState('');
	const [fileId, setFileId] = useState('');
	const [stDate, setStDate] = useState(new Date());
	const [enDate, setEnDate] = useState(new Date());
	const [loadFinish,setLoadFinish] = useState(false);

	const [thumbInfoList, setThumbInfoList] = React.useState<any[]>([]);

	//파일정보 선언
	const [thumbFileNm, setThumbFileNm] = useState('');
	const [dmdFileValue] = useState(new TbComFile());
	const [thumbFileValue] = useState(new TbComFile());
	const [fileValueTemp, setFileValue] = useState(new TbComFile());
	const fileValue = React.useDeferredValue(fileValueTemp);

	// 폼체크 여부
	const [formCheck,setFormCheck] = useState(false);

	//파일업로드
	const [uploadId, setUploadId] = React.useState("");
	const [uploadIdThumb, setUploadIdThumb] = React.useState("");

	const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);
	const [fileInfoListPop, setFileInfoListPop] = React.useState<any[]>([]);

	//파일업로드
	const onCreationComplete = function (uploadID: string) {
		setUploadId(uploadID);
	}

	//파일업로드 완료
	const onUploadComplete = (type) => {
		const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
		const arrayNew = dataArray.newFile;
		const arrayDel = dataArray.deleteFile;
		console.log(JSON.stringify(arrayNew));

		let fileInfos : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_GB:string;
			FILE_STATUS:string;
		}[] = [];

		let fileInfo : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_GB:string;
			FILE_STATUS:string;
		};

		//파일등록 정보
		arrayNew?.map((item, index) => {
			if(item.status =="complete"){
				fileInfo = {
					FILE_DETAIL_ID:item.uniqKey,
					ORGINL_FILE_NM:item.originalName,
					STRE_FILE_NM:item.uploadName,
					FILE_SIZE:item.size,
					STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
					FILE_EXTSN:item.extension,
					FILE_GB:type,
					FILE_STATUS:"ADD"
				}

				fileInfos.push(fileInfo);
			}

			console.log("fileInfos : "+JSON.stringify(fileInfos));
		})

		//파일등록 정보
		arrayDel?.forEach((item, index) => {
			fileInfo = {
				FILE_DETAIL_ID:item.uniqKey,
				ORGINL_FILE_NM:item.originalName,
				STRE_FILE_NM:item.uploadName,
				FILE_SIZE:item.size,
				STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
				FILE_EXTSN:item.extension,
				FILE_GB:type,
				FILE_STATUS:"DEL"
			}

			fileInfos.push(fileInfo);

		})
		setFileInfoList(fileInfos);

	}

	const onFileUpload = () => {
		if(uploadId){
			window["RAONKUPLOAD"].Transfer(uploadId);
		}
		setFormCheck(true);
	}

	/**
	 * 파일업로드 팝업
	 */
	const thumbModal = () => {
		let title = '이미지첨부';

		if(thumbFileNm != ''){
			UIUtils.alert('파일 삭제 후 진행해주세요').then();
			return;
		}

		UIUtils.openFileUploadPopup({
			title: title,
			buttonTitle: "등록",
			attrs: {
				MaxTotalFileCount: "1",
				ExtensionAllowOrLimit: "1",
			},
			valueChanged: async data => {
				console.log("fileId uploadId : "+ uploadId);
				// @ts-ignore
				if(data != undefined && data.tbComFileMapngDetailList.length != 0){
					const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
					const arrayNew = dataArray.newFile;
					const arrayDel = dataArray.deleteFile;
					console.log("arrayNew", JSON.stringify(arrayNew));

					let fileInfos : {
						FILE_DETAIL_ID:string | undefined;
						ORGINL_FILE_NM:string | undefined;
						STRE_FILE_NM:string | undefined;
						FILE_SIZE:number | undefined;
						STRE_PATH:string | undefined;
						FILE_EXTSN:string | undefined;
						FILE_GB:string | undefined;
						FILE_STATUS:string | undefined;
					}[] = [];

					let fileInfo : {
						FILE_DETAIL_ID:string | undefined;
						ORGINL_FILE_NM:string | undefined;
						STRE_FILE_NM:string | undefined;
						FILE_SIZE:number | undefined;
						STRE_PATH:string | undefined;
						FILE_EXTSN:string | undefined;
						FILE_GB:string | undefined;
						FILE_STATUS:string | undefined;
					};



					// @ts-ignore
					let item = data.tbComFileMapngDetailList[0];

					// @ts-ignore
					let uniqKey = item.uniqKey;
					// @ts-ignore
					let orginlFileNm = item.orginlFileNm;
					// @ts-ignore
					let streFileNm = item.streFileNm;
					// @ts-ignore
					let fileSize = item.fileSize;
					// @ts-ignore
					let strePath = item.strePath;
					// @ts-ignore
					let fileExtsn = item.fileExtsn;

					//파일등록 정보
					fileInfo = {
						FILE_DETAIL_ID:uniqKey,
						ORGINL_FILE_NM:orginlFileNm,
						STRE_FILE_NM:streFileNm,
						FILE_SIZE:fileSize,
						STRE_PATH: strePath,
						FILE_EXTSN:fileExtsn,
						FILE_GB:"THUMB",
						FILE_STATUS:"ADD"
					}
					// @ts-ignore
					setThumbFileNm(orginlFileNm);


					fileInfos.push(fileInfo);
					// console.log(fileInfoListPop);
					setFileInfoListPop(fileInfoListPop.concat(fileInfos));
				}


			}
		})

	}

	async function fileDelete(){

		// @ts-ignore
		let item;
		if(thumbFileValue.tbComFileMapngDetailList.length != 0){
			item = thumbFileValue.tbComFileMapngDetailList[0];
		}

		// console.log(item);

		if(item == undefined && fileInfoListPop.filter(a => a.FILE_GB == "THUMB").length != 0){
			let newList = [...fileInfoListPop];
			newList = newList.filter(a => a.FILE_GB != "THUMB")
			setFileInfoListPop(newList);
			UIUtils.alert('삭제 되었습니다.').then();
			// @ts-ignore
			setThumbFileNm('')
			return;
		}else if(item == undefined){
			UIUtils.alert('삭제 할 파일이 없습니다.').then();
			return;
		}

		if(await UIUtils.confirm('삭제하시겠습니까?')){

			setThumbFileNm('');

			let fileInfos : {
				FILE_DETAIL_ID:string | undefined;
				ORGINL_FILE_NM:string | undefined;
				STRE_FILE_NM:string | undefined;
				FILE_SIZE:number | undefined;
				STRE_PATH:string | undefined;
				FILE_EXTSN:string | undefined;
				FILE_GB:string | undefined;
				FILE_STATUS:string | undefined;
			}[] = [];

			let fileInfo : {
				FILE_DETAIL_ID:string | undefined;
				ORGINL_FILE_NM:string | undefined;
				STRE_FILE_NM:string | undefined;
				FILE_SIZE:number | undefined;
				STRE_PATH:string | undefined;
				FILE_EXTSN:string | undefined;
				FILE_GB:string | undefined;
				FILE_STATUS:string | undefined;
			};



			// @ts-ignore
			let uniqKey = item.fileDetailId;
			// @ts-ignore
			let orginlFileNm = item.orginlFileNm;
			// @ts-ignore
			let streFileNm = item.streFileNm;
			// @ts-ignore
			let fileSize = item.fileSize;
			// @ts-ignore
			let strePath = item.strePath;
			// @ts-ignore
			let fileExtsn = item.fileExtsn;

			//파일등록 정보
			fileInfo = {
				FILE_DETAIL_ID:uniqKey,
				ORGINL_FILE_NM:orginlFileNm,
				STRE_FILE_NM:streFileNm,
				FILE_SIZE:fileSize,
				STRE_PATH: strePath,
				FILE_EXTSN:fileExtsn,
				FILE_GB:"THUMB",
				FILE_STATUS:"DEL"
			}

			fileInfos.push(fileInfo);
			let newList = [...fileInfoListPop];
			setFileInfoListPop(newList.concat(fileInfos));
			UIUtils.alert('정상 처리 되었습니다 저장시 파일이 삭제 됩니다.').then();
		}

	}

	const handleSelect = (e) => {
		if(e.target.name === 'stsCd'){
			setStsCd(e.target.value);
		}
	};

	// 목록 이동
	async function onClickList(event) {
		event.preventDefault();
		let dataToSend = {DEMAND_NO : dmdNo};
		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './adm1701',
			state: { data: dataToSend }
		});

	};

	// 팝업 파일 업로드
	async function dmdFormCheck() {

		// 필수값 체크
		if(title == '' || cont == ''){
			await UIUtils.alert("필수입력이 완료되지않았습니다.\n 다시 확인해 주세요.").then();
			return;
		}

		if(thumbFileNm == '' ){
			await UIUtils.alert("필수입력이 완료되지않았습니다.\n 다시 확인해 주세요.").then();
			return;
		}

		if(await UIUtils.confirm('저장하시겠습니까?')){

			setFormCheck(true);
			// 파일 업로드
			await onFileUpload();
		}

	}

	// 상세조회
	async function getRead() {

		const response:any = await CommonUtil.execute({
			url: "adm_1701",
			data: {DEMAND_NO: dmdNo}
		}).then((response: any) => {
			const result = response;
			setTitle(response.TITLE);
			setStDate(new Date(response.ST_DATE));
			setEnDate(new Date(response.EN_DATE));
			setStsCd(response.STS_CD);
			setCont(response.CONT);
			setFileId(response.FILE_ID);

			// 파일이 있을경우
			let fileList = result.FILE_INFO;
			if(fileList.length > 0){
				for(let i=0; i<fileList.length; i++){

					if(fileList[i].FILE_GB == 'FILE'){
						let fileInfo = fileList[i];

						//파일등록 정보
						const fileDetail = new TbComFileMapngDetail();
						fileDetail.setDwldId(fileInfo.DWLD_ID);
						fileDetail.setFileDetailId(fileInfo.FILE_DETAIL_ID);
						fileDetail.setFilePolicy(fileInfo.FILE_POLICY);
						fileDetail.setFileRpstr(fileInfo.FILE_RPSTR);
						fileDetail.setStrePath(fileInfo.STRE_PATH);
						fileDetail.setStreFileNm(fileInfo.STRE_FILE_NM);
						fileDetail.setOrginlFileNm(fileInfo.ORGINL_FILE_NM);
						fileDetail.setFileExtsn(fileInfo.FILE_EXTSN);
						fileDetail.setFileSize(fileInfo.FILE_SIZE);
						fileDetail.setRegistPsnNm(fileInfo.REGIST_PSN_NM);
						fileDetail.setRegistDt(fileInfo.REGIST_DT);
						dmdFileValue.putTbComFileMapngDetailList(fileDetail);


					} else {
						let thumbInfo = fileList[i];

						//파일등록 정보
						const fileDetail = new TbComFileMapngDetail();
						fileDetail.setDwldId(thumbInfo.DWLD_ID);
						fileDetail.setFileDetailId(thumbInfo.FILE_DETAIL_ID);
						fileDetail.setFilePolicy(thumbInfo.FILE_POLICY);
						fileDetail.setFileRpstr(thumbInfo.FILE_RPSTR);
						fileDetail.setStrePath(thumbInfo.STRE_PATH);
						fileDetail.setStreFileNm(thumbInfo.STRE_FILE_NM);
						fileDetail.setOrginlFileNm(thumbInfo.ORGINL_FILE_NM);
						fileDetail.setFileExtsn(thumbInfo.FILE_EXTSN);
						fileDetail.setFileSize(thumbInfo.FILE_SIZE);
						fileDetail.setRegistPsnNm(thumbInfo.REGIST_PSN_NM);
						fileDetail.setRegistDt(thumbInfo.REGIST_DT);
						thumbFileValue.putTbComFileMapngDetailList(fileDetail);

						setThumbFileNm(thumbInfo.ORGINL_FILE_NM);

					}

				}
				//
				setFileValue(dmdFileValue);
			}
			setLoadFinish(true);

		}).catch((error) => {
			CommonUtil.showAxiosError(error);
			return;
		});

	}

	React.useEffect(() => {

		getRead();

	}, []);//effect

	// 파일 업로드 성공여부 체크
	React.useEffect(() => {
		if(fileInfoList && formCheck) {
			// 파일 업로드 성공
			let param ={
				DEMAND_NO : dmdNo,
				TITLE : title,
				ST_DATE : DateUtil.toDateFormat(stDate, "YYYYMMDDHHmmss"),
				EN_DATE : DateUtil.toDateFormat(enDate, "YYYYMMDDHHmmss"),
				STS_CD : stsCd,
				CONT : cont,
				THUMB_INFO_LIST:fileInfoListPop.concat(fileInfoList),
				FILE_INFO_LIST:fileInfoList.concat(fileInfoListPop),
				FILE_ID: fileId,
			}

			console.log("param : "+JSON.stringify(param));

			//내용 저장
			dmdSave(param);

		}
	}, [fileInfoList])


	async function dmdSave(sendParam:any){

		console.log("sendParam : "+JSON.stringify(sendParam));

		const response:any = await CommonUtil.execute({
			url:"adm_1703.jct",
			data: sendParam
		}).then((response: any) => {
			UIUtils.alert("저장되었습니다.").then(()=>{
				// 완료 후 상세화면으로 이동
				let dataToSend = { DEMAND_NO: dmdNo};
				history.push({
					pathname: './adm1701',
					state: { data: dataToSend }
				});
			});
		}).catch((error) => {
			CommonUtil.showAxiosError(error);
			return;
		});
	};

	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={0} lnbD1Idx={6}  lnbD2Idx={1}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">수요조사 안내문 수정</h1>
					<form className="fo fo-col2 mb30" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3 req">
								<p className="fo-key">제목</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={title} placeholder={''}
											 readOnly={false} valueChanged={(value) => setTitle(value)}/>
								</div>
							</div>
							<div className="fo-item req">
								<p className="fo-key">모집기간</p>
								<div className="fo-value">
									<div className="hz-root hz-gap5">
										<UIDatePicker className="hz-item" value={stDate}
													  valueChanged={(value) => setStDate(value)}/>
										<span className="hz-item">~</span>
										<UIDatePicker className="hz-item" value={enDate}
													  valueChanged={(value) => setEnDate(value)}/>
									</div>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">모집상태</p>
								<div className="fo-value">
									<div className="sl sl-md w100p">
										<select name="stsCd" id="notiStsCd" value={stsCd} className=""
												onChange={handleSelect}>
											<option value="Y">모집중</option>
											<option value="N">모집완료</option>
										</select>
									</div>
								</div>
							</div>
						</div>
					</form>

					<h3 className="section-title mb15">내용등록</h3>
						<UISunEditor value={cont} valueChanged={(value) => setCont(value)}/>
					<br/>

					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3 req">
								<p className="fo-key">썸네일 이미지</p>
								<div className="fo-value">
									<div className="fund-form-group">
										<div className="fund-form-items mr30">
											<div className="hz-root hz-gap8 w100p">
												<UIInput className={'tf tf-md hz-item grow'} value={thumbFileNm} placeholder={'이미지 파일을 첨부해 주세요(Jpg, gif, png파일)'}/>
												<div className="hz-root hz-gap8">
													<Button color='pri-o2' size="md" onClick={() => thumbModal()}>찾기</Button>
													<Button color='gray-o' size="md" onClick={() => fileDelete()}>삭제</Button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</form>
					<br/>

					<h3 className="section-title mb15">첨부파일</h3>
					<div className="fo-item fo-m-1-3">
						<div className="fo-value">
							<div className='w100p'>
								<UI.FileUpload
									onCreationComplete={onCreationComplete}
									onUploadComplete={() => onUploadComplete('FILE')}
									attrs={{
										MaxTotalFileCount: "5",
										ImgPreView: "99"
									}}
									value={fileValue}
								/>
							</div>
						</div>
					</div>
					<br/>

					<div className="hz-root hz-right hz-gap5">
						<Button color="gray-o" size="sm" onClick={onClickList}>취소</Button>
						<Button color="pri" size="sm" onClick={dmdFormCheck}>저장</Button>
					</div>

				</main>
			</div>
		</PageContainer>
	);
}

export default ContentsContainer;